import { render } from "./user-settlement.vue?vue&type=template&id=972d7c58"
import script from "./user-settlement.vue?vue&type=script&lang=js"
export * from "./user-settlement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__